import router, { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { Toast } from "common/ui/Toast";

import { useUnit } from "common/middleware/hooks";

export function PublishConfirmationToast() {
  const { query } = useRouter();
  const { t } = useTranslation("admin");
  const { unit } = useUnit(Number(query.propertyId));

  const listingState = unit?.state.toString();

  return unit && (
    <Toast
      close={() => router.replace(
        { query: { view: "published" } },
        undefined,
        { shallow: true }
      )}
      timeout={4000}
      alertIcon
      variant="success"
    >
      {t(listingState === "active"
        ? "publishConfirmationToast.active"
        : "publishConfirmationToast.scheduled", {
          address: unit.address.unitNumber ? `${unit.address.unitNumber} - ${unit.address.street}` : unit.address.street
        }
      )}
    </Toast>
  )
}
